
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericSlowFilled as ObiVesselGenericSlowFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-slow-filled.js';
 
 
 

 
 export const ObiVesselGenericSlowFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-slow-filled',
   elementClass: ObiVesselGenericSlowFilledElement,
   events: {
     
   }
  });
 
 